import { UserGroup } from "./userGroup";
import { PermissionEntry } from "./permissionEntry";

export class UserGroupDto {

    constructor(userGroup: UserGroup) {
        this.id = userGroup.id;
        this.companyLoginId = userGroup.companyLoginId;
        this.name = userGroup.name;
        this.roles = userGroup.roles;
        this.can_download = userGroup.can_download
        this.can_view = userGroup.can_view;
        this.can_order = userGroup.can_order;
        this.permissions = this.buildPermissionsMap(userGroup.permissions);
    }
    id: number;
    companyLoginId: string;
    name: string;
    roles: Array<string>;
    permissions: object;
    can_download: boolean;
    can_view: boolean;
    can_order: boolean;

    buildPermissionsMap(permissions: Map<string, PermissionEntry>): Object {
        let permissionsObject = {};
        if(permissions !== null) {
            permissions.forEach((permissionEntry, key) => {
                permissionsObject[key] = permissionEntry;
            })
        }

        return permissionsObject;
    }
}